import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import vi_VN from "@react-pdf-viewer/locales/lib/vi_VN.json";
import en_US from "@react-pdf-viewer/locales/lib/en_US.json";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const ReactPdfViewer = props => {
  const { filePdfUrl, style } = props;
  const { t, i18n } = useTranslation();

  const [pdfLang, setPdfLang] = useState(vi_VN);

  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const renderToolbar = () => {
    return (
      <React.Fragment>
        <Toolbar>
          {toolbarProps => {
            const {
              CurrentPageInput,
              SwitchTheme,
              Open,
              Download,
              EnterFullScreen,
              GoToNextPage,
              GoToPreviousPage,
              NumberOfPages,
              Print,
              ShowSearchPopover,
              Zoom,
              ZoomIn,
              ZoomOut,
              ShowProperties,
            } = toolbarProps;
            return (
              <React.Fragment>
                <div className="rpv-toolbar">
                  <div className="rpv-toolbar__left">
                    <ShowSearchPopover />
                    <GoToPreviousPage />
                    <CurrentPageInput /> / <NumberOfPages /> <GoToNextPage />
                  </div>
                  <div className="rpv-toolbar__center">
                    <ZoomOut /> <Zoom /> <ZoomIn />
                  </div>
                  <div className="rpv-toolbar__right">
                    {/* <SwitchTheme /> */}
                    <EnterFullScreen />
                    {/* <Open /> */} 
                    {/* <Download /> */}
                    <Print />
                    {/* <ShowProperties /> */}
                  </div>
                </div>
              </React.Fragment>
            );
          }}
        </Toolbar>
      </React.Fragment>
    );
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: defaultTabs => [
      defaultTabs[0], // Thumbnails tab
      defaultTabs[1], // Bookmarks tab
      defaultTabs[2], // Attachments tab
    ],
  });

  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setPdfLang(vi_VN);
        break;
      case "en":
        setPdfLang(en_US);
        break;
      default:
        break;
    }
  }, [t]);

  return (
    <React.Fragment>
      <div>
        {filePdfUrl && (
          <React.Fragment>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.js">
              <div
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  height: "75vh",
                  ...style,
                }}
              >
                <Viewer
                  fileUrl={filePdfUrl}
                  plugins={[defaultLayoutPluginInstance, toolbarPluginInstance]}
                  localization={pdfLang}
                />
              </div>
            </Worker>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

ReactPdfViewer.propTypes = {
  filePdfUrl: PropTypes.string.isRequired,
  style: PropTypes.object,
};

ReactPdfViewer.defaultProps = {
  filePdfUrl: "",
  style: {},
};

export default ReactPdfViewer;
